import React, { useEffect, useState } from "react";
import { Modal, Tab, Tabs, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getDdrmsRepositoryDocuments, loadDdrmsRepositoryDocs } from "../../store/ddrmsDocument";
import DataMapping from "./DataMapping";
import PurchaseOrderPopup from "../../../ReviewTools/PurchaseOrderPopup";

const GenerateContract = (props) => {
    const { showHide, uploadType, handleModalShowHide, workflowTask, app, applicantObj, viewType } = props;

    const [repositoryDocs, setRepositoryDocs] = useState([]);
    const [selectedDoc, setSelectedDoc] = useState(null);
    const [selectedDocId, setSelectedDocId] = useState(null);
    const [selectedKey, setSelectedKey] = useState("generate");
    const [poOrderType, setPoOrderType] = useState("add");
    const [purchaseShowHide, setPurchaseShowHide] = useState(false);
    const [candidateObj, setCandidateObj] = useState(null);

    const ddrmsRepositoryDocumentsSelector = useSelector(getDdrmsRepositoryDocuments);

    const dispatch = useDispatch();
    useEffect(() => {
        if (workflowTask?.ciid > 0) {
            dispatch(loadDdrmsRepositoryDocs(workflowTask.ciid));
            if ((uploadType === "Recruiter" || uploadType === "Sub-Contractors") && viewType === "") {
                console.log(applicantObj, "applicantObj in GenerateContract");
                //setCandidateObj(applicantObj);
                // if (applicantObj.contact1) {
                //     if (uploadType === "Recruiter") {
                //         setCandidateObj({
                //             ...applicantObj,
                //             subcontractor: null,
                //             recruiter: { ...applicantObj.contact1 }
                //         });
                //     } else {
                //         setCandidateObj({
                //             ...applicantObj,
                //             recruiter: null,
                //             subcontractor: { ...applicantObj.contact1 }
                //         });
                //     }
                // }
                setSelectedKey("generate");
            }
            else{
                setSelectedKey("poOrder");
            }
        }
    }, []);

    useEffect(() => {
        if (ddrmsRepositoryDocumentsSelector.length > 0) {
            const filterDocx = ddrmsRepositoryDocumentsSelector.filter(x => x.fileExtension === "docx");
            setRepositoryDocs(filterDocx);
        }
        else{
            setRepositoryDocs([]);
        }
    }, [ddrmsRepositoryDocumentsSelector]);

    const handleResetSelection = () => {
        setSelectedDocId(0);
        setSelectedDoc(null);
    }

    const handleSelection = (item) => {
        setSelectedDoc(item);
        setSelectedDocId(item.id);
    };

    const handleCloseMapping = (type) => {
        setSelectedDocId(0);
        setSelectedDoc(null);
        //setSelectedKey("home");
        setTimeout(() => {
            handleModalShowHide(type)
        }, 3000);
    }

    const handleSelectedKey = (key) => {
        setSelectedKey(key)
    }

    const handlePurchaseShowHide = (item, type, poOrderType) => {
        // setSelectedDocId(0);
        // setSelectedDoc(null);
        // setPoOrderType(poOrderType);
        // setPurchaseShowHide(true);
        // if (item) {
        //     setSelectedItem(item);
        // }
    }
    const handleSignUnsignPo = (poOrder) => {
        // Logic to sign or unsign the purchase order
    }
    const handleRefreshPoOrders = () => {
        // Logic to refresh the purchase orders
        if (uploadType !== "Recruiter")
            handleModalShowHide("save");
    }

    return <>
        <Modal show={showHide} size="xl">
            <Modal.Header closeButton onHide={() => handleModalShowHide("")}>
                <Modal.Title>Generate Documents</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Tabs
                    onSelect={handleSelectedKey}
                    activeKey={selectedKey}
                    //defaultActiveKey={"generate"}
                    id="uncontrolled-tab-example"
                    className="h3 border border-right-0 border-left-0 border-top-0 font-weight-normal"
                >
                    {viewType !== "candidateList" &&
                        <Tab eventKey="generate" title="Generate Documents" tabClassName="page-tab border border-left-0 border-top-0">
                            <Tab.Content className="border p-3 border-top-0">
                                {selectedDocId <= 0 && <>
                                    <div className="text-dark">Note : Only Supported Docx file</div>
                                    <button className="btn btn-sm btn-link pl-0" onClick={handleResetSelection}>Reset Selection</button>
                                    <div className="table-responsive bg-white"
                                        style={{ maxHeight: "500px", overflow: "auto" }}>
                                        <table className="table align-items-center table-flush table-hover table-striped border">
                                            <thead className="thead-light">
                                                <tr>
                                                    <th>Select</th>
                                                    <th>ID</th>
                                                    <th>Contract Template</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {repositoryDocs.map((item) => (
                                                    <tr>
                                                        <td>
                                                            <div className="custom-control custom-radio">
                                                                <input
                                                                    className="custom-control-input"
                                                                    type="radio"
                                                                    id={item.id}
                                                                    name="role"
                                                                    onChange={() => handleSelection(item)}
                                                                    value={selectedDocId}
                                                                    checked={selectedDocId === item.id}
                                                                    disabled={item.fileExtension !== "docx"}
                                                                />
                                                                <label
                                                                    className="custom-control-label"
                                                                    htmlFor={item.id}
                                                                >
                                                                </label>
                                                            </div>
                                                        </td>
                                                        <td>{item.id}</td>
                                                        <td>{item.name}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </>}
                                {selectedDocId > 0 &&
                                    <DataMapping
                                        workflowTask={workflowTask}
                                        app={app}
                                        uploadType={uploadType}
                                        selectedObj={selectedDoc}
                                        applicantObj={applicantObj}
                                        viewType={viewType}
                                        handleCloseMapping={handleCloseMapping} />
                                }
                            </Tab.Content>
                        </Tab>}
                    {viewType === "candidateList" &&
                        <Tab eventKey="poOrder" title="Generate/Upload Purchase Order" tabClassName="page-tab border border-left-0 border-right-0 border-top-0">
                            <Tab.Content className="border p-3 border-top-0">
                                {selectedKey === "poOrder" &&
                                    <PurchaseOrderPopup
                                        purchaseShowHide={true}
                                        handlePurchaseShowHide={handlePurchaseShowHide}
                                        candidateObj={applicantObj}
                                        workflowTask={workflowTask}
                                        poOrderType={poOrderType}
                                        item={{ partnerType: uploadType === "Recruiter" ? "Recruiter" : "Sub-Contractors" }}
                                        handleSignUnsignPo={handleSignUnsignPo}
                                        handleRefreshPoOrders={handleRefreshPoOrders}
                                        renderType="generate"
                                    ></PurchaseOrderPopup>}
                            </Tab.Content>
                        </Tab>}
                </Tabs>
            </Modal.Body>
            {/* <Modal.Footer>
                <button className="btn btn-sm btn-outline-default" onClick={()=>handleModalShowHide("")}>
                    <i class="fa fa-times" aria-hidden="true"></i> Close
                </button>
            </Modal.Footer> */}
        </Modal>
    </>

}

export default GenerateContract;